import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProduct } from '@/hooks/useProduct';
import { useProfileModal } from '@/contexts/ProfileModalContext';
import { PageLoader } from '@/components/ui/loading-skeletons';

/**
 * Redirects legacy /profile routes to the dashboard and opens the ProfileModal.
 * This maintains backwards compatibility with old URLs.
 */
export function ProfileRedirect() {
  const navigate = useNavigate();
  const { productId } = useProduct();
  const { openProfileModal } = useProfileModal();

  useEffect(() => {
    // Navigate to dashboard
    navigate(`/${productId}/dashboard`, { replace: true });
    
    // Open profile modal after a short delay to ensure the dashboard has rendered
    const timer = setTimeout(() => {
      openProfileModal();
    }, 100);

    return () => clearTimeout(timer);
  }, [navigate, productId, openProfileModal]);

  // Show loading while redirecting
  return <PageLoader />;
}
